import { render, staticRenderFns } from "./FooterModular.vue?vue&type=template&id=437e608f&scoped=true&"
import script from "./FooterModular.vue?vue&type=script&lang=js&"
export * from "./FooterModular.vue?vue&type=script&lang=js&"
import style0 from "./FooterModular.vue?vue&type=style&index=0&id=437e608f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e608f",
  null
  
)

export default component.exports